import { formatISO, startOfMonth, subMonths } from "date-fns";
import { Init } from "./types";

export const pageOptions = [
  // { value: 5, text: 5 }, /////////////data grid versiyon//////////////////
  // { value: 10, text: 10 },
  { value: 20, text: 20 },
  { value: 50, text: 50 },
  { value: 100, text: 100 },
  { value: 250, text: 250 }, //////////////////table versiyon///////////////
  { value: 500, text: 500 },
  { value: 10000, text: "Show a lot" },
];

export const rowList = {
  currency: [
    "company_buy_price",
    "company_sell_price",
    "company_gain",
    "site_buy_price",
    "site_sell_price",
    "site_gain",
    "pin_price",
    "store_buy_price",
    "store_sell_price",
    "store_gain",
    "company_price",
    "site_price",
    "vat_price",
    "company_old_balance",
    "company_balance",
    "site_old_balance",
    "site_balance",
    "store_old_balance",
    "store_balance",
    "store_price",
    "value_price",
    "reseller_price",
    "recharge",
    "old_balance",
    "balance",
    "credit",
    "credit_limit",
    "rate_price",
    "incoming_price",
    "outgoing_price",
    "price",
    "customer_price",
    "total_price",
    "purchase_price",
    "one_time_phone_price",
    "total_tax",
    "gross_price",
    "net_price",
    "total_store_price",
    "total_value",
    "total_provision",
    "default_price",
    "payment",
    "shop_balance",
    "provision",
    "total_cost",
    "total_site",
    "total_value",
    "total_company",
    "total_store",
    "avis",
    "daily_total",
    "daily_limit",
    "shop_old_balance",
    "shop_credit",
    "shop_credit_limit",
    "invoice_total",
    "invoice_total_tax",
    "topup_2",
    "topup_3",
    "product_value",
    "provision_price",
    "total_provision",
    "net_price_with_tax",
    "net_price_without_tax",
    "tax_price",
    "net_provision_price_with_tax",
    "net_provision_price_without_tax",
    "provision_discount_price",
    "provision_tax_price",
    "total_commission",
    "commission_amount",
    "basket_price",
    "gain",
    "cost_price",
  ],
  date: [
    "created_at",
    "arrival_date",
    "paid_date",
    "invoice_date",
    "last_sale_at",
    "started_at",
    "ended_at",
    "updated_at",
    "datum",
    "assign_date",
    "stock_enter_date",
    "simcard_date",
    "last_login_at",
    "upload_date",
    "expire_date",
    "activation_date",
  ],
  detail: [
    "bank_name",
    "user_name",
    "pin",
    "store_informations",
    "site_title",
    "buyer_site_title",
    "site",
    "name",
    "user",
    "store",
    "brand",
    "brand_title",
    "assigned_by",
    "representative_name",
    "api_name",
    "brand_name",
    "title",
    "phone_title",
    "package_title",
    "company_title",
    "tariff_price",
    "promotion_price",
    "phone_price",
    "invoice_no",
    "device_info",
    "product_name",
    "product_type",
    "package_info",
    "name",
    "order_no",
    "order_id",
    "store_code",
    "store_title",
    "proccessing_person",
    "product_title",
    "supplier",
    "description",
    "city",
    "daily_limit_noprice",
    "daily_total_noprice",
    "canvas_title",
    "code",
    "total_noprice",
    "bank",
    "remark",
    "buyer",
    "seller",
  ],
  percent: ["pin_discount", "site_discount", "discount", "store_discount", "rate_discount", "company_discount", "total_vat", "commission_rate"],
  lookup: ["type", "sale_type", "category", "invoice_type", "operation"],
  status: [
    "status",
    "Status",
    "active",
    "banned",
    "loading",
    "stock",
    "available",
    "sales",
    "order",
    "survey",
    "primary",
    "paid",
    "approved",
    "scanned",
    "last_sale_status",
    "relation_status",
    "defined",
    "is_read",
    "control_status",
  ],
  discount_type: ["discount_type"],
  ids: ["id", "pin_token"],
  operations: ["token"],
  sale_id: ["sale_id"],
  value: ["value"],
  users: ["waiting", "opus", "boss", "representative", "receiver", "trusty", "gender", "employe"],
  bannerItem: ["item"],
  walletOp: ["confirm"],
  htmlClean: ["note"],
  icon: ["icon", "flag", "show"],
  localicon: ["basket", "transfer", "order_type", "local_button", "cancel"],
  checkbox: ["checkbox"],
  image: ["image"],
  href: ["pdf", "invoice", "document"],
  brandList: ["vodafone", "o2", "lyca", "ortel", "ayyildiz-prepaid", "ayyildiz-postpaid", "lebara"],
  cdnImage: ["logo"],
  keyword: ["keyword"],
};

export const keywordIconList = [
  "waybill",
  "card-return",
  "company-pin-return",
  "invoice",
  "manuel-provision",
  "phone",
  "pin-return",
  "plane",
  "postpaid-provision",
  "prepaid-provision",
  "proforma",
  "return",
  "site-manuel-return",
  "site-pin-return",
  "standart_provision",
];

export const invoiceTypes = {
  "pin-sale": "E-Pin Verkauf",
  "pin-return": "E-Pin Gutschrift",
  "gap-fill": "Kommentar",
  "site-pin-sale": "Reseller E-Pin Verkauf",
  "site-pin-return": "Reseller E-Pin Gutschrift",
  "company-pin-sale": "Distributor E-Pin Verkauf",
  "company-pin-return": "Distributor E-Pin Gutschrift",
  "manuel-provision": "Provision",
  receipt: "Beleg",
  waybill: "Lieferschein",
  "store-sim-sale": "Händler Sim Karten verkauf",
  proforma: "Proforma",
  "site-sim-sale": "Reseller Sim Karten verkauf",
  "site-sim-return": "Reseller Sim Karten Gutschrift",
  "store-sim-return": "Händler Sim Karten Gutschrift",
  "site-manuel-sale": "Rückforderung",
  plane: "Flugticket",
  service: "Service",
  standart_provision: "Standart Provision",
  "company-manuel-return": "Distributor Gutschrift",
  "prepaid-provision": "Prepaid Provision",
  "site-manuel-return": "Reseller Gutschrift",
  rentacar: "Rent a Car",
  "postpaid-provision": "Postpaid Provision",
  phone: "Mobilfunk",
  "company-manuel-sale": "Distributor Verkauf",
  "transaction-fee": "Transaktionsgebühr",
  "card-sale": "Kartenverkauf",
  "card-return": "Kartengutschrift",
};

export const defaultInit: Init = {
  page_info: { title: "", icon: "", api_url: "" },
  page_head: [],
  table_nav: [],
  rules: {},
  table_head: [],
  items: [],
};

export const initialApi = {
  create: "",
  read: "",
  update: "",
  delete: "",
};

export const links = [
  {
    to: { name: "/Admin/Store/Users/[token]" },
    icon: "mdi mdi-account-group-outline",
    title: "Users",
  },
  {
    to: { name: "/Admin/Store/Balance/[token]" },
    icon: "mdi mdi-wallet-outline",
    title: "Balance",
  },
  {
    to: { name: "/Admin/Store/Discount/[token]" },
    icon: "mdi mdi-percent-box-outline",
    title: "Discount",
  },
  {
    to: { name: "/Admin/Store/Sales/[token]" },
    icon: "mdi mdi-chart-areaspline",
    title: "Sales",
  },
  {
    to: { name: "/Admin/Store/[token]" },
    icon: "mdi mdi-cog-outline",
    title: "Settings",
  },
  {
    to: { name: "/Admin/Store/Summary/[token]" },
    icon: "mdi mdi-notification-clear-all",
    title: "Total",
  },
];

const tnow = new Date();
const yyyy = tnow.getFullYear();
const currentMonth = tnow.getMonth() + 1;

const getMonths = [];

for (let i = 2020; i <= yyyy; i++) {
  for (let m = 1; m <= 12; m++) {
    if (i === yyyy && m > currentMonth) {
      break;
    }

    const month = m < 10 ? "0" + m : m.toString();
    getMonths.push(`${i}-${month}`);
  }
}

const today = new Date();
const formattedToday = formatISO(today, { representation: "date" });
const threeMonthsAgo = subMonths(today, 3);
const _3monthsAgo = formatISO(threeMonthsAgo, { representation: "date" });
const oneMonthAgo = subMonths(today, 1);
const _1monthAgo = formatISO(oneMonthAgo, { representation: "date" });
const twoMonthAgo = subMonths(today, 2);
const _2monthAgo = formatISO(twoMonthAgo, { representation: "date" });
const firstDayOfMonth = formatISO(startOfMonth(today), { representation: "date" });

export const formatDate = (rawDate: any) => {
  const dateObj = new Date(rawDate);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  const hours = String(dateObj.getHours()).toString().padStart(2, "0");
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");
  const seconds = dateObj.getSeconds().toString().padStart(2, "0");

  if (`${day}-${month}-${year} ${hours}:${minutes}:${seconds}` === "NaN-NaN-NaN NaN:NaN:NaN" || rawDate === null) {
    return "--";
  } else if (`${hours}:${minutes}:${seconds}` === "03:00:00") {
    return `${day}.${month}.${year}`;
  } else return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
};

export const nowTime = () => {
  const getNow = new Date();
  const options = { timeZone: "Europe/Berlin" };
  const now = getNow.toLocaleTimeString("de-DE", options);

  return now;
};

// International Top Up: pinCode aslında hedef telefon numarası; fişte menü ve seri no basılmaz.
export const TOPUP_PIN_SERIAL = "7QLNCoHPbLTqvjoB";

export const dates = {
  monthList: getMonths.reverse(),
  today: formattedToday,
  aMonthago: _1monthAgo,
  twoMonthago: _2monthAgo,
  ago: _3monthsAgo,
  firstDay: firstDayOfMonth,
};

export const createPhoneRequired = [
  {
    field: "title",
    type: "text",
    label: "Title",
    required: true,
    value: "",
  },
  {
    field: "sub_title",
    type: "text",
    label: "Subtitle",
    required: true,
    value: "",
  },
  {
    field: "price",
    type: "number",
    label: "Price",
    required: true,
    value: "",
  },
  {
    field: "slug",
    type: "text",
    label: "slug",
    required: true,
    value: "",
  },
];

export const lists = {
  areaCodeList: [
    { label: "151", value: "151" },
    { label: "1511", value: "1511" },
    { label: "1512", value: "1512" },
    { label: "1514", value: "1514" },
    { label: "1515", value: "1515" },
    { label: "1516", value: "1516" },
    { label: "1517", value: "1517" },
    { label: "15180", value: "15180" },
    { label: "15181", value: "15181" },
    { label: "1520", value: "1520" },
    { label: "1521", value: "1521" },
    { label: "1522", value: "1522" },
    { label: "1523", value: "1523" },
    { label: "1525", value: "1525" },
    { label: "1526", value: "1526" },
    { label: "1529", value: "1529" },
    { label: "15510", value: "15510" },
    { label: "15511", value: "15511" },
    { label: "15566", value: "15566" },
    { label: "15678", value: "15678" },
    { label: "1570", value: "1570" },
    { label: "1573", value: "1573" },
    { label: "1575", value: "1575" },
    { label: "1577", value: "1577" },
    { label: "1578", value: "1578" },
    { label: "1579", value: "1579" },
    { label: "15888", value: "15888" },
    { label: "1590", value: "1590" },
    { label: "160", value: "160" },
    { label: "162", value: "162" },
    { label: "163", value: "163" },
    { label: "170", value: "170" },
    { label: "171", value: "171" },
    { label: "172", value: "172" },
    { label: "173", value: "173" },
    { label: "174", value: "174" },
    { label: "175", value: "175" },
    { label: "176", value: "176" },
    { label: "177", value: "177" },
    { label: "178", value: "178" },
    { label: "179", value: "179" },
  ],
  idTypeList: [
    { label: "Personalausweis", value: "IDENTIFICATION_CARD" },
    { label: "Reisepass", value: "PASSPORT" },
  ],
  genderList: [
    { label: "Herr", value: 0 },
    { label: "Frau", value: 1 },
  ],
  titleList: [
    { label: "Bitte Wähle.", value: null },
    { label: "Dipl.-Betriebsw.", value: 0 },
    { label: "Dipl.-Finw.", value: 1 },
    { label: "Dipl.-Ing.", value: 2 },
    { label: "Dipl.-Ing. (FH)", value: 3 },
    { label: "Dipl.-Phys.", value: 4 },
    { label: "Dipl.-Psych.", value: 5 },
    { label: "Dipl.-Ök.", value: 6 },
    { label: "Dr.", value: 7 },
    { label: "Dr. Dr.", value: 8 },
    { label: "Dr. Phil.", value: 9 },
    { label: "Dr. jur.", value: 10 },
    { label: "Dr. med.", value: 11 },
    { label: "Dr. med. vet.", value: 12 },
    { label: "General", value: 13 },
    { label: "Phd.", value: 14 },
    { label: "Prof.", value: 15 },
    { label: "Prof. Dr.", value: 16 },
    { label: "Prof. Dr. Dr.", value: 17 },
    { label: "Prof. Dr. jur.", value: 18 },
    { label: "Prof. Dr. med.", value: 19 },
  ],
  countryList: [
    { label: "Deutschland", value: "DE" },
    { label: "Afghanistan", value: "AF" },
    { label: "Ägypten", value: "EG" },
    { label: "Aland", value: "AX" },
    { label: "Albanien", value: "AL" },
    { label: "Algerien", value: "DZ" },
    { label: "Amerikanische Jungferninseln", value: "VI" },
    { label: "Amerikanisch-Samoa", value: "AS" },
    { label: "Andorra", value: "AD" },
    { label: "Angola", value: "AO" },
    { label: "Anguilla", value: "AI" },
    { label: "Antarktis", value: "AQ" },
    { label: "Antigua und Barbuda", value: "AG" },
    { label: "Äquatorialguinea", value: "GQ" },
    { label: "Argentinien", value: "AR" },
    { label: "Armenien", value: "AM" },
    { label: "Aruba", value: "AW" },
    { label: "Aserbaidschan", value: "AZ" },
    { label: "Äthiopien", value: "ET" },
    { label: "Australien", value: "AU" },
    { label: "Bahamas", value: "BS" },
    { label: "Bahrain", value: "BH" },
    { label: "Bangladesch", value: "BD" },
    { label: "Barbados", value: "BB" },
    { label: "Belarus (Weißrußland)", value: "BY" },
    { label: "Belgien", value: "BE" },
    { label: "Belize", value: "BZ" },
    { label: "Benin", value: "BJ" },
    { label: "Bermuda", value: "BM" },
    { label: "Bhutan", value: "BT" },
    { label: "Bolivien", value: "BO" },
    { label: "Bonaire, Sint Eustatius und Sa", value: "BQ" },
    { label: "Bosnien-Herzegowina", value: "BA" },
    { label: "Botsuana", value: "BW" },
    { label: "Bouvetinsel", value: "BV" },
    { label: "Brasilien", value: "BR" },
    { label: "Britische Jungferninseln", value: "VG" },
    { label: "Britisches Territorium im Indi", value: "IO" },
    { label: "Brunei Darussalam", value: "BN" },
    { label: "Bulgarien", value: "BG" },
    { label: "Burkina Faso", value: "BF" },
    { label: "Burundi", value: "BI" },
    { label: "Chile", value: "CL" },
    { label: "China", value: "CN" },
    { label: "Cookinseln", value: "CK" },
    { label: "Costa Rica", value: "CR" },
    { label: "Cote dIvoire", value: "CI" },
    { label: "Curaçao", value: "CW" },
    { label: "Dänemark", value: "DK" },
    { label: "Dominica", value: "DM" },
    { label: "Dominikanische Republik", value: "DO" },
    { label: "Dschibuti", value: "DJ" },
    { label: "Ecuador", value: "EC" },
    { label: "El Salvador", value: "SV" },
    { label: "Eritrea", value: "ER" },
    { label: "Estland", value: "EE" },
    { label: "Falklandinseln", value: "FK" },
    { label: "Färöer", value: "FO" },
    { label: "Fidschi", value: "FJ" },
    { label: "Finnland", value: "FI" },
    { label: "Frankreich", value: "FR" },
    { label: "Französische Süd- und Antarkti", value: "TF" },
    { label: "Französisch-Guayana", value: "GF" },
    { label: "Französisch-Polynesien", value: "PF" },
    { label: "Gabun", value: "GA" },
    { label: "Gambia", value: "GM" },
    { label: "Georgien", value: "GE" },
    { label: "Ghana", value: "GH" },
    { label: "Gibraltar", value: "GI" },
    { label: "Grenada", value: "GD" },
    { label: "Griechenland", value: "GR" },
    { label: "Grönland", value: "GL" },
    { label: "Großbritannien", value: "GB" },
    { label: "Guadeloupe", value: "GP" },
    { label: "Guam", value: "GU" },
    { label: "Guatemala", value: "GT" },
    { label: "Guernsey (Kanalinsel)", value: "GG" },
    { label: "Guinea", value: "GN" },
    { label: "Guinea-Bissau", value: "GW" },
    { label: "Guyana", value: "GY" },
    { label: "Haiti", value: "HT" },
    { label: "Heard und McDonaldinseln", value: "HM" },
    { label: "Honduras", value: "HN" },
    { label: "Hongkong", value: "HK" },
    { label: "Indien", value: "IN" },
    { label: "Indonesien", value: "ID" },
    { label: "Insel Man", value: "IM" },
    { label: "Irak", value: "IQ" },
    { label: "Iran", value: "IR" },
    { label: "Irland", value: "IE" },
    { label: "Island", value: "IS" },
    { label: "Israel", value: "IL" },
    { label: "Italien", value: "IT" },
    { label: "Jamaika", value: "JM" },
    { label: "Japan", value: "JP" },
    { label: "Jemen", value: "YE" },
    { label: "Jersey (Kanalinsel)", value: "JE" },
    { label: "Jordanien", value: "JO" },
    { label: "Jugoslawien (Serb. / Mo.)", value: "YU" },
    { label: "Kaimaninseln", value: "KY" },
    { label: "Kambodscha", value: "KH" },
    { label: "Kamerun", value: "CM" },
    { label: "Kanada", value: "CA" },
    { label: "Kap Verde", value: "CV" },
    { label: "Kasachstan", value: "KZ" },
    { label: "Katar", value: "QA" },
    { label: "Kenia", value: "KE" },
    { label: "Kirgisistan", value: "KG" },
    { label: "Kiribati", value: "KI" },
    { label: "Kokosinseln", value: "CC" },
    { label: "Kolumbien", value: "CO" },
    { label: "Komoren", value: "KM" },
    { label: "Kongo", value: "CG" },
    { label: "Kongo, Demokratische Republik", value: "CD" },
    { label: "Korea", value: "KR" },
    { label: "Korea (Demokratische VR)", value: "KP" },
    { label: "Kosovo", value: "XK" },
    { label: "Kroatien", value: "HR" },
    { label: "Kuba", value: "CU" },
    { label: "Kuwait", value: "KW" },
    { label: "Laos", value: "LA" },
    { label: "Lesotho", value: "LS" },
    { label: "Lettland", value: "LV" },
    { label: "Libanon", value: "LB" },
    { label: "Liberia", value: "LR" },
    { label: "Libyen", value: "LY" },
    { label: "Liechtenstein", value: "LI" },
    { label: "Litauen", value: "LT" },
    { label: "Luxemburg", value: "LU" },
    { label: "Macau", value: "MO" },
    { label: "Madagaskar", value: "MG" },
    { label: "Malawi", value: "MW" },
    { label: "Malaysia", value: "MY" },
    { label: "Malediven", value: "MV" },
    { label: "Mali", value: "ML" },
    { label: "Malta", value: "MT" },
    { label: "Marokko", value: "MA" },
    { label: "Marshallinseln", value: "MH" },
    { label: "Martinique", value: "MQ" },
    { label: "Mauretanien", value: "MR" },
    { label: "Mauritius", value: "MU" },
    { label: "Mayotte", value: "YT" },
    { label: "Mazedonien", value: "MK" },
    { label: "Mexiko", value: "MX" },
    { label: "Mikronesien", value: "FM" },
    { label: "Moldau (Republik)", value: "MD" },
    { label: "Monaco", value: "MC" },
    { label: "Mongolei", value: "MN" },
    { label: "Montenegro", value: "ME" },
    { label: "Montserrat", value: "MS" },
    { label: "Mosambik", value: "MZ" },
    { label: "Myanmar", value: "MM" },
    { label: "Namibia", value: "NA" },
    { label: "Nauru", value: "NR" },
    { label: "Nepal", value: "NP" },
    { label: "Neukaledonien", value: "NC" },
    { label: "Neuseeland", value: "NZ" },
    { label: "Nicaragua", value: "NI" },
    { label: "Niederlande", value: "NL" },
    { label: "Niederländische Antillen", value: "AN" },
    { label: "Niger", value: "NE" },
    { label: "Nigeria", value: "NG" },
    { label: "Niue", value: "NU" },
    { label: ">Nordirland", value: "GB" },
    { label: "Nördliche Marianen", value: "MP" },
    { label: "Norfolkinsel", value: "NF" },
    { label: "Norwegen", value: "NO" },
    { label: "Oman", value: "OM" },
    { label: "Österreich", value: "AT" },
    { label: "Pakistan", value: "PK" },
    { label: "Palästinens. Autonomiegebiet", value: "PS" },
    { label: "Palau", value: "PW" },
    { label: "Panama", value: "PA" },
    { label: "Papua-Neuguinea", value: "PG" },
    { label: "Paraguay", value: "PY" },
    { label: "Peru", value: "PE" },
    { label: "Philippinien", value: "PH" },
    { label: "Pitcairninseln", value: "PN" },
    { label: "Polen", value: "PL" },
    { label: "Portugal", value: "PT" },
    { label: "Puerto Rico", value: "PR" },
    { label: "Reunion", value: "RE" },
    { label: "Ruanda", value: "RW" },
    { label: "Rumänien", value: "RO" },
    { label: "Russische Föderation", value: "RU" },
    { label: "Saint-Barthélemy", value: "BL" },
    { label: "Saint-Martin (franz. Teil)", value: "MF" },
    { label: "Salomonen", value: "SB" },
    { label: "Sambia", value: "ZM" },
    { label: "Samoa", value: "WS" },
    { label: "San Marino", value: "SM" },
    { label: "Sao Tome und Principe", value: "ST" },
    { label: "Saudi-Arabien", value: "SA" },
    { label: "Schweden", value: "SE" },
    { label: "Schweiz", value: "CH" },
    { label: "Senegal", value: "SN" },
    { label: "Serbien", value: "RS" },
    { label: "Seychellen", value: "SC" },
    { label: "Sierra Leone", value: "SL" },
    { label: "Simbabwe", value: "ZW" },
    { label: "Singapur", value: "SG" },
    { label: "Sint Maarten (niederl. Teil)", value: "SX" },
    { label: "Slowakische Republik", value: "SK" },
    { label: "Slowenien", value: "SI" },
    { label: "Somalia", value: "SO" },
    { label: "Sonstige", value: "XX" },
    { label: "Spanien", value: "ES" },
    { label: "Sri Lanka", value: "LK" },
    { label: "St. Helena", value: "SH" },
    { label: "St. Kitts und Nevis", value: "KN" },
    { label: "St. Lucia", value: "LC" },
    { label: "St. Pierre und Miquelon", value: "PM" },
    { label: "St. Vincent und die Grenadinen", value: "VC" },
    { label: "Staatenlos", value: "XX" },
    { label: "Südafrika", value: "ZA" },
    { label: "Sudan", value: "SD" },
    { label: "Südgeorgien und die Südlichen", value: "GS" },
    { label: "Südsudan", value: "SS" },
    { label: "Suriname", value: "SR" },
    { label: "Svalbard und Jan Mayen", value: "SJ" },
    { label: "Swasiland", value: "SZ" },
    { label: "Syrien", value: "SY" },
    { label: "Tadschikistan", value: "TJ" },
    { label: "Taiwan", value: "TW" },
    { label: "Tansania", value: "TZ" },
    { label: "Thailand", value: "TH" },
    { label: "Timor-Leste", value: "TL" },
    { label: "Togo", value: "TG" },
    { label: "Tokelau", value: "TK" },
    { label: "Tonga", value: "TO" },
    { label: "Trinidad und Tobago", value: "TT" },
    { label: "Tschad", value: "TD" },
    { label: "Tschechische Republik", value: "CZ" },
    { label: "Tschechoslowakei (ehemalig)", value: "CS" },
    { label: "Tunesien", value: "TN" },
    { label: "Türkei", value: "TR" },
    { label: "Turkmenistan", value: "TM" },
    { label: "Turks- und Caicosinseln", value: "TC" },
    { label: "Tuvalu", value: "TV" },
    { label: "UdSSR (jetzt: Russische Födera", value: "SU" },
    { label: "Uganda", value: "UG" },
    { label: "Ukraine", value: "UA" },
    { label: "Ungarn", value: "HU" },
    { label: "United States Minor Outlying I", value: "UM" },
    { label: "Uruguay", value: "UY" },
    { label: "USA", value: "US" },
    { label: "Usbekistan", value: "UZ" },
    { label: "Vanuatu", value: "VU" },
    { label: "Vatikanstadt", value: "VA" },
    { label: "Venezuela", value: "VE" },
    { label: "Vereinigte Arabische Emirate", value: "AE" },
    { label: "Vietnam", value: "VN" },
    { label: "Wallis und Futuna", value: "WF" },
    { label: "Weihnachtsinsel", value: "CX" },
    { label: "Westsahara", value: "EH" },
    { label: "Zentralafrikanische Republik", value: "CF" },
    { label: "Zypern", value: "CY" },
  ],
  operatorList: [
    { value: "489", label: "Telekom (TMOB)" },
    { value: "501", label: "Vodafone (VODA)" },
    { value: "366", label: "Congstar (CONG)" },
    { value: "346", label: "1&amp;1 (1UN1)" },
    { value: "413", label: "Klarmobil (KLAR)" },
    { value: "427", label: "Mobilcom (MOBC)" },
    { value: "480", label: "Talkline (TALK)" },
    { value: "500", label: "Victorvox (VICT)" },
    { value: "430", label: "Müller Mobile (MOBC)" },
    { value: "495", label: "1GLOBAL Truphone (TRUP)" },
    { value: "345", label: "1&amp;1 (1UN1) o2 Netz" },
    { value: "347", label: "4B Flexz (TURK)" },
    { value: "348", label: "Aetka smart (EPLU)" },
    { value: "349", label: "Aldi Talk (EPLU)" },
    { value: "350", label: "Allmobil (OTLO)" },
    { value: "351", label: "Alphatel (ALPH)" },
    { value: "352", label: "Amiva (TEL2)" },
    { value: "353", label: "AY YILDIZ (EPLU)" },
    { value: "354", label: "BILDconnect (VICT)" },
    { value: "355", label: "BILDmobil (MOCO" },
    { value: "356", label: "Blacksim (VICT)" },
    { value: "357", label: "Blau (BLAU)" },
    { value: "358", label: "Blauworld (ORTE)" },
    { value: "359", label: "Bling Mobile (TURK)" },
    { value: "361", label: "Bunte Mobil (BLAU)" },
    { value: "360", label: "Bunte Mobil (O2DE)" },
    { value: "362", label: "Cellway (CELL)" },
    { value: "364", label: "Chip Mobile (BLAU)" },
    { value: "363", label: "Chip Mobile (O2DE)" },
    { value: "365", label: "Chixx (WOOD)" },
    { value: "367", label: "Crash (MOBC)" },
    { value: "368", label: "Cybersim (VICT)" },
    { value: "369", label: "Debitel (DEBI)" },
    { value: "372", label: "Deutschland Sim (MSIM)" },
    { value: "371", label: "Deutschland Sim (RSLC)" },
    { value: "370", label: "Deutschland Sim (VICT)" },
    { value: "374", label: "DiscoTEL (MSIM)" },
    { value: "373", label: "DiscoTel (VICT)" },
    { value: "375", label: "DOKOM21 (DOKO)" },
    { value: "376", label: "DR SIM (KLAR)" },
    { value: "377", label: "Drillisch (DRIL)" },
    { value: "378", label: "EasyTel (ETEL)" },
    { value: "379", label: "EasyTel (WOOD))" },
    { value: "380", label: "EDEKA smart (TDM2)" },
    { value: "381", label: "ENTEGA (TEL2)" },
    { value: "382", label: "ESIM.me (ESIM)" },
    { value: "385", label: "Eteleon (MSIM)" },
    { value: "384", label: "Eteleon (RSLC)" },
    { value: "383", label: "Eteleon (VICT)" },
    { value: "386", label: "EWE (EWET)" },
    { value: "388", label: "FamilyMobile (KLAR)" },
    { value: "387", label: "FamilyMobile (MOBC)" },
    { value: "389", label: "FCB Mobil (TURK)" },
    { value: "390", label: "Fonic (FONI)" },
    { value: "391", label: "Fraenk (CONG)" },
    { value: "392", label: "Freenet FLEX (KLAR)" },
    { value: "393", label: "Freenet FUNK (MOBC)" },
    { value: "394", label: "freenetMobile (KLAR)" },
    { value: "395", label: "FreePhone (1UN1)" },
    { value: "396", label: "Free-Prepaid (VICT)" },
    { value: "397", label: "FYVE (CYWL)" },
    { value: "398", label: "Galaxyexperte (VICT)" },
    { value: "399", label: "GALERIA mobil (GALM)" },
    { value: "400", label: "GMX FreePhone (VICT)" },
    { value: "401", label: "Handyvertrag (VICT)" },
    { value: "403", label: "HappySIM (KLAR)" },
    { value: "402", label: "HappySIM (MOBC)" },
    { value: "404", label: "Hellomobil (VICT)" },
    { value: "405", label: "HFO Telecom Hof (HFOH)" },
    { value: "406", label: "HIGH (HIGH)" },
    { value: "407", label: "Htp GmbH (TALK)" },
    { value: "408", label: "Htp Hannover (HTPH)" },
    { value: "409", label: "HUMANS mobile (HUMA)" },
    { value: "410", label: "Ja mobil REWE (CONS)" },
    { value: "411", label: "Kaufland mobil (TURK)" },
    { value: "412", label: "KEVAG Telekom Koblenz" },
    { value: "414", label: "Lebara (LEBA)" },
    { value: "415", label: "Lets Go Mobile (O2DE)" },
    { value: "416", label: "Lidl Connect (LIDL)" },
    { value: "417", label: "Lycamobile (LYCA)" },
    { value: "418", label: "Maingau Mobilfunk (MAIN)" },
    { value: "419", label: "Maxi Mobil (MNET)" },
    { value: "420", label: "MaXXim (MSIM)" },
    { value: "421", label: "MaXXim (VICT)" },
    { value: "422", label: "McSIM (VICT)" },
    { value: "424", label: "Media Markt Super Select (SERV)" },
    { value: "425", label: "Mega SIM (MOBC)" },
    { value: "423", label: "M-Net Mobil (MNET)" },
    { value: "426", label: "Mobi (VODA)" },
    { value: "428", label: "Mobil09 (ETEL)" },
    { value: "429", label: "MTEL Germany (MTEL)" },
    { value: "431", label: "Multiconnect (MUCC)" },
    { value: "432", label: "NAKED Mobile (HUMA)" },
    { value: "433", label: "NetCologne Dienste (NEDI)" },
    { value: "434", label: "NetCom BW Ellwangen (NETB)" },
    { value: "435", label: "NetCom Kassel (NCKS)" },
    { value: "436", label: "NettoKOM (BLAU)" },
    { value: "437", label: "NORMA CONNECT (TDM2)" },
    { value: "438", label: "NSIM (NSIM)" },
    { value: "439", label: "NTTCable Mobilfunk (TALK)" },
    { value: "443", label: "Ortel Mobile (ORTE)" },
    { value: "444", label: "Osnatel (EWET)" },
    { value: "446", label: "Otelo (OTLO)" },
    { value: "445", label: "Otelo (VODA)" },
    { value: "442", label: "O2 Geschäftskunden (O2DE)" },
    { value: "440", label: "O2 Mobile Postpaid (O2DE)" },
    { value: "441", label: "O2 Prepaid Loop (O2DE)" },
    { value: "447", label: "Paketsparer (PRIG)" },
    { value: "448", label: "Penny Mobil (CONS)" },
    { value: "449", label: "Premium SIM (RSLC))" },
    { value: "450", label: "Premium SIM (Victorvox)" },
    { value: "451", label: "Primacall (PRIG)" },
    { value: "452", label: "Primamobile (PRIG)" },
    { value: "453", label: "Primastrom (PRIG)" },
    { value: "454", label: "PureMobile (MOCO)" },
    { value: "455", label: "Rossmann (ALMO)" },
    { value: "456", label: "Rossmann Otelo (OTLO)" },
    { value: "457", label: "Saturn Super Select (SERV)" },
    { value: "458", label: "SC-Fan-Tarife (WOOD)" },
    { value: "459", label: "Sdt.net Aalen (SDTN)" },
    { value: "460", label: "Share mobile (TURK)" },
    { value: "461", label: "Sim de (VICT)" },
    { value: "463", label: "SimDiscount (VICT)" },
    { value: "464", label: "SIMon mobile (MOCO)" },
    { value: "465", label: "Simply (MSIM)" },
    { value: "466", label: "Simply (VICT)" },
    { value: "467", label: "Simplytel (VICT)" },
    { value: "468", label: "Simyo (BLAU)" },
    { value: "462", label: "Sim24 (VICT)" },
    { value: "469", label: "Sipgate Argon (VINT)" },
    { value: "470", label: "Smartmobil (MSIM)" },
    { value: "471", label: "Smartmobil (VICT)" },
    { value: "472", label: "Sparhandy (SPHA)" },
    { value: "473", label: "Spezialtarif Osteuropa (ORTE)" },
    { value: "474", label: "Spice Mobile (ORTE)" },
    { value: "475", label: "Spusu (MUCC)" },
    { value: "476", label: "Stadtwerke Schwedt (SSWE)" },
    { value: "478", label: "Super Illu Mobil (BLAU)" },
    { value: "477", label: "Super Illu Mobil (O2DE)" },
    { value: "479", label: "Swb (EWET)" },
    { value: "482", label: "Tarifhaus (BLAU)" },
    { value: "481", label: "Tarifhaus (O2DE)" },
    { value: "483", label: "Tchibo Mobil (O2DE)" },
    { value: "484", label: "Teams (TEAM)" },
    { value: "486", label: "Telco (MSIM)" },
    { value: "485", label: "Telco Services (RSLC)" },
    { value: "487", label: "Telco (VICT)" },
    { value: "488", label: "TelcoVillage (TEVI)" },
    { value: "490", label: "The DOT (TDOT)" },
    { value: "492", label: "TKS easyMobile (TKS1)" },
    { value: "493", label: "TNG Stadtnetz Kiel (TNGS)" },
    { value: "491", label: "TNKM (TNKM)" },
    { value: "494", label: "TOGGO mobil (MOCO)" },
    { value: "497", label: "TV Spielfilm talk &amp; Surf (BLAU)" },
    { value: "496", label: "TV Spielfilm talk &amp; Surf (O2DE)" },
    { value: "498", label: "Twilio (TWLO)" },
    { value: "499", label: "VARIAtel (VARI)" },
    { value: "502", label: "Voiceworks Enreach (ONEP)" },
    { value: "503", label: "Voxenergie (PRIG)" },
    { value: "504", label: "WEB de eSIM (VICT)" },
    { value: "505", label: "WETell (TEL2)" },
    { value: "506", label: "WhatsApp SIM (EPLU)" },
    { value: "507", label: "Wilhelm.tel Norderstedt (WTEL)" },
    { value: "508", label: "Willy tel Hamburg (WTEL)" },
    { value: "509", label: "WinSIM (VICT)" },
    { value: "510", label: "WN-Mobilfunk (WOOD)" },
    { value: "511", label: "WOBCOM Wolfsburg (WOBC)" },
    { value: "512", label: "Woodman (WOOD)" },
    { value: "513", label: "WorkSide (WORK)" },
    { value: "514", label: "XA.AX (XAAX)" },
    { value: "515", label: "XPLORA Deutschland (XPLO)" },
    { value: "516", label: "Yourfone (VICT)" },
  ],
  customerTypeList: [
    { label: "Privatkunde", value: "Privatkunde" },
    // { label: "Geschäftskunde", value: "BUSINESS" },
  ],
};

export const statusClass = [
  { status: 0, color: "info", class: "mdi mdi-timer-sand-paused" },
  { status: 1, color: "success", class: "mdi mdi-check-circle-outline" },
  { status: 2, color: "warning", class: "mdi mdi-chat-alert" },
  { status: 3, color: "destructive", class: "mdi mdi-bug-outline" },
  { status: 4, color: "destructive", class: "mdi mdi-store-off-outline" },
  { status: 5, color: "warning", class: "mdi mdi-timer-sand" },
  { status: 6, color: "info", class: "mdi mdi-coffee-outline" },
  { status: 7, color: "success", class: "mdi mdi-check-circle-outline" },
  { status: 8, color: "info", class: "mdi mdi-clipboard-list-outline" },
  { status: 9, color: "destructive", class: "mdi mdi-stamper" },
  { status: 10, color: "success", class: "mdi mdi-check-circle-outline" },
  { status: 11, color: "success", class: "mdi mdi-check-circle-outline" },
  { status: 12, color: "success", class: "mdi mdi-check-circle-outline" },
  { status: 13, color: "success", class: "mdi mdi-check-circle-outline" },
  { status: 14, color: "success", class: "mdi mdi-check-circle-outline" },
];

export const months = () => {
  const tnow = new Date();
  const yyyy = tnow.getFullYear();
  const currentMonth = tnow.getMonth() + 1;
  const monthsList = [];
  const monthNames: any = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };
  for (let i = 2020; i <= yyyy; i++) {
    for (let m = 1; m <= 12; m++) {
      if (i === yyyy && m > currentMonth) {
        break;
      }

      const month = m < 10 ? "0" + m : m.toString();

      const firstDay = `${i}-${month}-01`;
      const lastDay = new Date(i, m, 1).toISOString().split("T")[0];

      monthsList.push({
        month: `${i}-${month}`,
        firstDay,
        lastDay,
        monthName: monthNames[m],
      });
    }
  }
  return monthsList;
};

export const statusList = [
  { label: "Storniert", value: "0" },
  { label: "Verkaufsrechnung", value: "1" },
  { label: "Rücksenderechnung", value: "2" },
];

/** Card (Kartenverkauf) faturaları için kullanılan kısıtlı status listesi. */
export const cardStatusList = [
  { label: "ProvisionRechnung", value: "1" },
  { label: "Storno", value: "2" },
];

export const MAX_BASKET_AMOUNT = 300;

export const refundReasonsList = [
  { value: "in_correct_purchase", label: "Falscher Einkauf" },
  { value: "defective_pin", label: "Pin Defekt/Fehler" },
];

export const DEFAULT_HANDY_GAIN = 50;
